/* staff-ecommerce · Método Chen, curso completo.
   Regla de la casa: nada nace oculto esperando un script. Si este archivo no carga,
   la página se lee entera igual; acá solo se suma movimiento y comodidad. */
(function () {
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var quieto = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* 1) el celular del hero: el video aparece recién cuando hay un cuadro pintado */
  var v = $('[data-feed]');
  if (v) {
    var red = navigator.connection || {};
    var pobre = red.saveData || /2g/.test(red.effectiveType || '');
    if (!quieto && !pobre) {
      v.addEventListener('timeupdate', function () { v.classList.add('anda'); }, { once: true });
      var arrancar = function () { var p = v.play(); if (p && p.catch) p.catch(function () {}); };
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (es) {
          es.forEach(function (e) { if (e.isIntersecting) arrancar(); else v.pause(); });
        }, { threshold: 0.2 }).observe(v);
      } else arrancar();
    }
  }

  /* 2) la línea del programa: el riel se llena a medida que se baja */
  var linea = $('[data-linea]');
  if (linea) {
    var riel = $('.riel', linea), etapas = $$('.etapa', linea), pend = false;
    var medir = function () {
      pend = false;
      var r = linea.getBoundingClientRect(), vh = window.innerHeight || 800;
      var lleno = Math.max(0, Math.min(r.height, vh * 0.55 - r.top));
      riel.style.setProperty('--lleno', lleno + 'px');
      etapas.forEach(function (e) { if (e.getBoundingClientRect().top < vh * 0.7) e.classList.add('ya'); });
    };
    window.addEventListener('scroll', function () { if (!pend) { pend = true; requestAnimationFrame(medir); } }, { passive: true });
    window.addEventListener('resize', medir);
    medir();
  }

  /* 3) estructura de un video: pestañas que pasan solas hasta que la persona toca una */
  $$('[data-tabs]').forEach(function (caja) {
    var bs = $$('[data-tab]', caja), ps = $$('[data-panel]', caja), ts = $$('.tiempo i', caja), i = 0, reloj = null, tocado = false;
    var ver = function (k) {
      i = (k + bs.length) % bs.length;
      bs.forEach(function (b, j) { b.setAttribute('aria-selected', j === i ? 'true' : 'false'); b.tabIndex = j === i ? 0 : -1; });
      ps.forEach(function (p, j) { p.classList.toggle('ver', j === i); });
      ts.forEach(function (t, j) { t.classList.toggle('act', j === i); });
    };
    caja.addEventListener('click', function (e) {
      var b = e.target.closest('[data-tab]'); if (!b) return;
      tocado = true; clearInterval(reloj); ver(+b.dataset.tab);
    });
    caja.addEventListener('keydown', function (e) {
      if (!e.target.closest('[data-tab]')) return;
      if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
      tocado = true; clearInterval(reloj);
      ver(i + (e.key === 'ArrowRight' ? 1 : -1)); bs[i].focus();
    });
    ver(0);
    /* los cuadros de las otras pestañas se piden al acercarse, para que el cambio no parpadee */
    if ('IntersectionObserver' in window) {
      var cerca = new IntersectionObserver(function (es) {
        if (!es[0].isIntersecting) return;
        $$('img', caja).forEach(function (im) { im.loading = 'eager'; });
        cerca.disconnect();
      }, { rootMargin: '600px' });
      cerca.observe(caja);
    }
    if (!quieto && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (es) {
        es.forEach(function (en) {
          clearInterval(reloj);
          if (en.isIntersecting && !tocado) reloj = setInterval(function () { ver(i + 1); }, 4200);
        });
      }, { threshold: 0.4 }).observe(caja);
    }
  });

  /* 4) carril de capturas: flechas */
  $$('[data-carril]').forEach(function (caja) {
    var c = $('.carril', caja);
    var paso = function (d) {
      var f = $('figure', c); if (!f) return;
      c.scrollBy({ left: d * (f.getBoundingClientRect().width + 12), behavior: quieto ? 'auto' : 'smooth' });
    };
    caja.addEventListener('click', function (e) {
      if (e.target.closest('[data-ant]')) paso(-1);
      else if (e.target.closest('[data-sig]')) paso(1);
    });
  });

  /* 5) barra fija del celular: aparece cuando el botón del hero ya no se ve y se va al llegar a la oferta */
  var barra = $('[data-barra]'), bh = $('[data-boton-hero]'), bo = $('[data-boton-oferta]');
  if (barra && bh && 'IntersectionObserver' in window) {
    var heroVisto = true, ofertaVista = false;
    var pintar = function () { barra.classList.toggle('ver', !heroVisto && !ofertaVista); };
    new IntersectionObserver(function (es) { heroVisto = es[0].isIntersecting; pintar(); }).observe(bh);
    if (bo) new IntersectionObserver(function (es) { ofertaVista = es[0].isIntersecting; pintar(); }).observe(bo);
  }

  /* 6) menú del celular: se cierra al elegir una sección */
  var menu = $('.menu');
  if (menu) menu.addEventListener('click', function (e) { if (e.target.closest('a')) menu.removeAttribute('open'); });

  var anio = $('[data-anio]');
  if (anio) anio.textContent = new Date().getFullYear();
})();
